<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
import '../js/tools';
import kahakii from "../js/kahakii";
import moment from "moment";


export default {
  name: "app",
  data() {
    return {}
  },
  methods: {},
  mounted() {
    let ka = JSON.parse(kahakii.TracerJson());
    let webdata = {
      display: ka.display,
      os: ka.os,
      language: ka.language,
      platform: ka.platform,
      hash: ka.hash,
      font: ka.font,
      canvas: ka.canvas
    }
    $.post("../api/SaveWebData", {webData: webdata}, () => {
    });
  }
}
</script>
<style scoped></style>